import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
const WITHOUT = ["Juegas del lado equivocado", "Copias golpes de diestro", "Chocas con tu compañero", "Te atacan el punto débil", "Entrenas sin plan", "Freno de mano puesto"];
const WITH = ["Eliges tu lado con criterio", "Golpes zurdos adaptados", "Pareja coordinada", "Explotas tu ventaja zurda", "Plan de 8 semanas claro", "Juegas a tu máximo nivel"];
export function ComparisonTable() {
  return <div className="grid grid-cols-2 gap-2.5" data-id="element-101" data-mp="3mec8iohffm6v">
      {/* Sin */}
      <div className="flex flex-col overflow-hidden rounded-2xl border border-red-500/25 bg-red-500/[0.06]" data-id="element-102" data-mp="3mbpz0jaz6wm0">
        <div className="bg-red-500/15 px-3 py-2.5 text-center" data-id="element-103" data-mp="38gfcpuasrjt9">
          <p className="text-[13px] font-extrabold text-red-300" data-id="element-104" data-mp="3dbkv4j4zqgcl">
            Sin Padel Zurdo Pro
          </p>
        </div>
        <ul className="flex flex-1 flex-col gap-2 p-3" data-id="element-105" data-mp="1x18rgf2z5r7r">
          {WITHOUT.map((t, i) => <li key={i} className="flex items-start gap-1.5" data-id="element-106" data-mp="21vw7dpjwxdaq" data-mpi={i}>
              <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-red-400" data-id="element-107" data-mp="2dygs9r33fetw" />
              <span className="text-[11.5px] leading-tight text-white/70" data-id="element-108" data-mp="29wbvwkl9g43k">
                {t}
              </span>
            </li>)}
        </ul>
      </div>

      {/* Con */}
      <div className="flex flex-col overflow-hidden rounded-2xl border border-[#d4ff00]/40 bg-[#d4ff00]/[0.06]" data-id="element-109" data-mp="2iwrzrv5x1d8y">
        <div className="bg-[#d4ff00]/20 px-3 py-2.5 text-center" data-id="element-110" data-mp="2wvrr5aktc68t">
          <p className="text-[13px] font-extrabold text-[#d4ff00]" data-id="element-111" data-mp="2wtx2bl6f7tzg">
            Con Padel Zurdo Pro
          </p>
        </div>
        <ul className="flex flex-1 flex-col gap-2 p-3" data-id="element-112" data-mp="36mm9i3uxuloz">
          {WITH.map((t, i) => <li key={i} className="flex items-start gap-1.5" data-id="element-113" data-mp="31n9rpxixc4t9" data-mpi={i}>
              <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#d4ff00]" data-id="element-114" data-mp="31p2xzbpmkn0q" />
              <span className="text-[11.5px] font-medium leading-tight text-white" data-id="element-115" data-mp="3gksamj8x7nss">
                {t}
              </span>
            </li>)}
        </ul>
      </div>
    </div>;
}